import { Injectable } from '@angular/core';
import { ProductColor } from './product-color.dto';
import { HttpService } from '@damofire/data-angular-commons';
import { ID_FIELD_OPTIONS, PRODUCT_COLORS_COLLECTION, Query, QueryService, SearchResult } from '@damofire/data-commons';
import { collection, collectionData, doc, getDoc, getFirestore, snapToData } from '@angular/fire/firestore';
import { debounceTime, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { firestore } from 'firebase-admin';
import DocumentData = firestore.DocumentData;

@Injectable()
export abstract class ProductColorService {
  abstract get(id: string): Promise<ProductColor>;
  abstract create(color: ProductColor): Promise<ProductColor>;
  abstract search(query: Query): Observable<SearchResult<ProductColor>>;
  abstract delete(id: string): Promise<void>;
}

@Injectable()
export class HttpProductColorService extends ProductColorService {
  constructor(private readonly http: HttpService) {
    super();
  }

  get(id: string): Promise<ProductColor> {
    return getDoc<ProductColor, DocumentData>(doc(getFirestore(), `${PRODUCT_COLORS_COLLECTION}/${id}`)).then((snap) => snapToData(snap, ID_FIELD_OPTIONS));
  }

  async create(color: Partial<ProductColor>): Promise<ProductColor> {
    return this.http.post('repos-colors', color);
  }

  search(queryObj: Query): Observable<SearchResult<ProductColor>> {
    return collectionData<ProductColor>(collection(getFirestore(), PRODUCT_COLORS_COLLECTION), { idField: '_id' }).pipe(
      debounceTime(200),
      map((colors) => QueryService.searchCollection(colors, queryObj, ['name'])),
    );
  }

  async delete(id: string): Promise<void> {
    return this.http.delete(`repos-colors/${id}`);
  }
}
